import { combineReducers } from "@reduxjs/toolkit";
import { commonReducer } from "../../modules/common";
import { configurationReducer } from "../../modules/configuration";
import { languageReducer } from "../../modules/language";
import { osservatorioReducer } from "../../modules/osservatorio";

// Importare eventuali altri reducers ed aggiungerli qua sotto

const applicationReducers = combineReducers({
  common: commonReducer,
  configuration: configurationReducer,
  language: languageReducer,
  osservatorio: osservatorioReducer,
});

export const createReducers = () => {
  return applicationReducers;
};
